export function defineAction(ctx, actionName, action) {
    ctx[actionName] = action.bind(ctx, ctx);
}
export function defineActions(ctx, actions) {
    for (const actionName of Object.keys(actions)) {
        const action = actions[actionName];
        defineAction(ctx, actionName, action);
    }
}
//# sourceMappingURL=define.js.map